import { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { useSignOut } from '../auth/useSignOut';
import { COPY } from '../copy';
import { useSession } from '../session/useSession';

const MENU_ID = 'account-menu';

/** First character of the first two words, upper-cased. */
function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join('');
}

export function AccountMenu() {
  const { me, tenantName } = useSession();
  const { busy, run } = useSignOut();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = anchorEl !== null;

  return (
    <>
      <IconButton
        aria-label={COPY.accountMenuLabel}
        aria-haspopup="menu"
        aria-controls={open ? MENU_ID : undefined}
        aria-expanded={open ? true : undefined}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <Avatar sx={{ width: (t) => t.spacing(4), height: (t) => t.spacing(4) }}>
          {initials(me.displayName)}
        </Avatar>
      </IconButton>
      <Menu id={MENU_ID} anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        <Box sx={{ px: 2, py: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {me.displayName}
          </Typography>
          {me.displayEmail !== null && (
            <Typography variant="caption" component="p" color="text.secondary">
              {me.displayEmail}
            </Typography>
          )}
          <Typography variant="caption" component="p" color="text.secondary">
            {tenantName}
          </Typography>
        </Box>
        <Divider />
        <MenuItem onClick={run} disabled={busy}>
          {COPY.signOut}
        </MenuItem>
      </Menu>
    </>
  );
}
